/* eslint-disable */
import HttpService from '../HttpService';
export default class CarrierService {
    constructor() {
      this._httpService = new HttpService('/contract/carrier');
      this._httpSdiService = new HttpService('/sdi/calendar-movements');
    }

    async FindAll(financialGroupIds = null) {
      const params = `?onlyMainFields=true${
        financialGroupIds
          ? `&financialGroups=${financialGroupIds}`
          : ''
      }`;
      return await this._httpService.get(params);
    }

    async FindAllWithFilters(queryString) {
      const queryParameters = queryString ? `?${queryString}&onlyMainFields=true` : '?onlyMainFields=true';
      return await this._httpService.get(`${queryParameters}`);
    }

    async FindById(id) {
      return await this._httpService.get(`/${id}?onlyMainFields=true`);
    }

    async GetAllowedDates(ids, movementType, eventDate, beneficiaryContractedPlanId) {
      return await this._httpSdiService.get(`/movement-calendar?parentContractIds=${ids}&movementType=${movementType.toUpperCase()}${eventDate ? `&eventDate=${eventDate}` : ''}${beneficiaryContractedPlanId ? `&beneficiaryContractedPlanId=${beneficiaryContractedPlanId}` : ''}`);
    }

    async FindByIds(ids) {
      return await this._httpService.get(`/findAllByIds?ids=${ids}&onlyMainFields=true`);
    }

 };
